"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../_util/utils");
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  Paragraph
} = _antd.Typography;
const getIsI18nChildren = children => {
  return /\{\{\{.+\}\}\}/.test(children);
};
const EllipsisTooltip = _ref => {
  let {
    tooltip = true,
    width,
    children,
    placement,
    getPopupContainer,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    style,
    className,
    overlayStyle,
    ...restProps
  } = _ref;
  const baseClassName = "".concat(prefixClass, "-ellipsisTooltip");
  const attrs = (0, _utils.pickDomAttrs)(restProps);
  const [ellipsisFlag, setEllipsisFlag] = (0, _react.useState)(false);
  if (children === undefined) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
    title: ellipsisFlag && tooltip ? children : undefined,
    placement: placement,
    overlayStyle: overlayStyle,
    getPopupContainer: getPopupContainer,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Paragraph, {
      ...attrs.data,
      className: (0, _classnames.default)(baseClassName, className),
      style: {
        width,
        lineHeight: 1.571429,
        ...style
      },
      ellipsis: getIsI18nChildren(children) ? false : {
        rows: 1,
        onEllipsis: flag => {
          setEllipsisFlag(flag);
        }
      },
      children: children
    })
  });
};
var _default = exports.default = EllipsisTooltip;